import React from "react";
import "./style.css";

export const NavBar = ({ left, right, children }) => {
    return (
        <div>
            {children &&
                <div className="navigation">
                    {children}
                </div>
            }

            {!children && <div className="navigation-2">
                {/* Left slot (for AddonButton, etc.) */}
                {left && <div className="nav-left">{left}</div>}

                {/* Right slot (Back / ExportCSV) */}
                {right && <div className="nav-right">{right}</div>}
            </div>
            }
        </div >
    );
};

export default NavBar;